import { Language } from "../constant";

export class BudgetAvailableRequest {
    checkIn: string;
    checkOut: string;
    companyId: number;
    totalQuantity: number;
    totalSellingPrice: number;
    page: string;
    lang = Language.en;
    shareBudgetCode? : string;
    destinationId: number;
}

export class BudgetAvailableResponse {
    totalAvailableBudget: number;
    totalAvailableBudgetBooker: number;
    totalAvailableBudgetCoBooker: number;
    totalOverBudget: number;
    budgetPerYear: BudgetPerYear[];
    budgetPerMonth: BudgetPerMonth[];
    budgetPerYearCoBooker: BudgetPerYear[];
    budgetPerMonthCoBooker: BudgetPerMonth[];
}

export class BudgetPerYear {
    year: number;
    availableBudget: number;
    overBudget: number;
}

export class BudgetPerMonth {
    month: number;
    year: number;
    availableBudget: number;
    overBudget: number;
}

export class User {
    userId: number;
    companyId: number;
    mainBooker: boolean;

    constructor(userId: number, companyId: number, mainBooker: boolean) {
        this.userId = userId;
        this.companyId = companyId;
        this.mainBooker = mainBooker;
    }
}


// WEBPACK FOOTER //
// ./src/app/model/cart/budget-available.model.ts